import React, { useContext } from "react";
import { Outlet } from 'react-router-dom';
import NotAuthorized from "../components/layouts/errors/NotAuthorized";
import { PermissionContext } from 'context/Context';
import PropTypes from 'prop-types';

const ProtectedRoute = ({permissionNo}) => {
  const { permissions = {} } = useContext(PermissionContext);

  const hasPermission = (permissionNo) => {
    // If no permissionNo provided, treat as public route
    if (!permissionNo) return true;
    return permissions[permissionNo] === true;
  };

  return hasPermission(permissionNo) ? <Outlet /> : <NotAuthorized />;
};

ProtectedRoute.propTypes = {
  permissionNo: PropTypes.string,
};

export default ProtectedRoute;
